import {createAllActions} from 'web-app/util/redux/typed-action-helpers';
import {type APIVoucher, type APIUpdateVoucher} from 'web-app/react/entities/recurring-payments/api';
import {type Optional} from 'web-app/util/typescript';

import type * as Types from '../types';

const domain = 'BILL_PAYER_PROFILE_V2/VOUCHER_MODAL';

export const {
    action: save,
    success: saveSuccess,
    failed: saveFailed,
} = createAllActions(
    `${domain}/SAVE`,
    (payload: {
        institutionId: string;
        billPayerId: string;
        voucherCompany: Types.VoucherCompany;
        payment: Optional<APIVoucher['recurringPayment'], 'voucherCompany'>;
    }) => payload,
    () => ({}),
    (error: Error) => error,
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAllActions(
    `${domain}/UPDATE`,
    (payload: {institutionId: string; billPayerId: string; recurringPaymentId: string; voucher: APIUpdateVoucher}) =>
        payload,
    () => ({}),
    (error: Error) => error,
);

export const {
    action: deleteVoucher,
    success: deleteVoucherSuccess,
    failed: deleteVoucherFailed,
    aborted: deleteVoucherAborted,
} = createAllActions(
    `${domain}/DELETE`,
    (payload: {institutionId: string; billPayerId: string; recurringPaymentId: string}) => payload,
    () => ({}),
    (error: Error) => error,
);
